/**
 * Returns `name` guaranteed to end in `.<extension>`, appending it when absent.
 * Idempotent and case-insensitive, and trims both inputs so a stray trailing
 * space in a filename cannot defeat the check (which would otherwise double the
 * extension). Returns the trimmed name unchanged when `extension` is empty.
 */
export function ensureFileExtension(name: string, extension: string): string {
  const trimmedName = name.trim();
  const ext = extension.trim().replace(/^\./, "");
  if (ext.length === 0) {
    return trimmedName;
  }
  if (trimmedName.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) {
    return trimmedName;
  }
  return `${trimmedName}.${ext}`;
}
